<template>
    <div>
        <canvas ref="halfCircleCanvas"></canvas>
        <p class="text-center" style="margin-top: -20px;">
            Completed: ${{ value_progress.total_completed_amount }} <br />
           
            Remaining: ${{ value_progress.total_target_value > 0 ? (value_progress.total_target_value - value_progress.total_completed_amount) : 0 }}
        </p>
    </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    name: 'HalfCircleChart',
    props: {
        value_progress: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.renderChart();
    },
    watch: {
        value_progress: {
            deep: true,
            immediate: true,
            handler() {
                console.log('this is reactive !!!!11');
                this.renderChart(); // Re-render chart when value_progress changes
            }
        }
    },
    methods: {
        renderChart() {
            // Use $nextTick to ensure the canvas is rendered before accessing it
            this.$nextTick(() => {
                const canvas = this.$refs.halfCircleCanvas;
                if (!canvas) return;

                const ctx = canvas.getContext('2d');
                if (!ctx) return;

                const completedPercentage = this.value_progress.total_target_value > 0
                    ? (this.value_progress.total_completed_amount * 100) / this.value_progress.total_target_value
                    : 0;

                const remainingPercentage = this.value_progress.total_target_value > 0
                    ? 100 - completedPercentage
                    : 100;

                // Destroy any existing chart to avoid memory leaks or issues
                if (this.chart) {
                    this.chart.destroy();
                }

                // Create the doughnut chart
                this.chart = new Chart(ctx, {
                    type: 'doughnut',
                    data: {
                        labels: ['Completed', 'Remaining'],
                        datasets: [{
                            data: [completedPercentage, remainingPercentage],
                            backgroundColor: ['#c1f1fd', '#fb7289'],
                            borderColor: '#000000',
                            borderWidth: 1
                        }]
                    },
                    options: {
                        responsive: true,
                        cutoutPercentage: 80,
                        rotation: -Math.PI, // Start from the left
                        circumference: Math.PI, // Half-circle
                        tooltips: {
                            enabled: false
                        }
                    }
                });
            });
        }
    }
}
</script>

<style>
canvas {
    height: 200px;
    width: 200px;
}
</style>
